/*eslint-env es6 */
require('./scss/main.scss');

import React from 'react';
import { render } from 'react-dom';

import InfoBox from './components/InfoBox';

export const init = (domContainer) => {
  const infoBox = render(<InfoBox/>, domContainer);
  return {
    showStatus: infoBox.showStatus,
    hide: infoBox.hide,
  }
};
